import { createVNode as a, mergeProps as n } from "vue";
import d from "../node_modules/@pf-ui/pf-icon-svg/es/asn/FolderTwotoneStandard.js";
import l from "../components/PfIcon.js";
const o = (r, t) => {
  const e = {
    ...r,
    ...t.attrs
  };
  return a(l, n(e, {
    icon: d
  }), null);
};
o.displayName = "FolderTwotoneStandard";
o.inheritAttrs = !1;
export {
  o as default
};
